import axios from "axios";
import ApiLogReport from './apiLogReport'

axios.defaults.withCredentials = true

const instance = axios.create({
	baseURL: '',
	timeout: 30000,
	withCredentials: true,
});


instance.interceptors.response.use(function(config){
  /* do something */
  return config
})

export default async function(url, data={}, method="",withCredentials = true, enablePost = true) { //enablePost控制post的传参问题,解决fetCollection()报错问题
  const defaultMethod = {
    OPTIONS: "OPTIONS",
    GET: "GET",
    HEAD: "HEAD",
    POST: "POST",
    PUT: "PUT",
    DELETE: "DELETE",
    TRACE: "TRACE",
    CONNECT: "CONNECT",
  };

  method = defaultMethod[method.toUpperCase()] ? defaultMethod[method.toUpperCase()] : "GET";
  const responseType = data["responseType"] ? data["responseType"] : "";
  const headers = data["headers"] ? data["headers"] : { 'content-type': 'application/json' };
  const cancelToken = data["cancelToken"] ? data["cancelToken"] : null;

  data = data["params"] ? data["params"] : data;

  const requestObj = {url, headers, method, responseType, withCredentials,enablePost};

  if((method == 'PUT' || method == 'POST' || method == 'PATCH') && enablePost) {
    requestObj.data = data;
  }else {
    requestObj.params = data;
  }

  if (cancelToken) {
    requestObj.cancelToken = cancelToken;
  }
  return instance.request(requestObj).then((respone) => {
    if(respone.status !== 200 && respone.status >= 400) {
      ApiLogReport(requestObj, respone)
    }
    return respone.data;
  }).catch(err => {
    ApiLogReport(requestObj, err)
  });
}



